<template lang='pug'>
  table-list(no-data='No Uncommitted Changes'
    :loading='loading'
    :items='changes'
    :total='total'
    :has-selection='false'
    :select-all='false'
    :headers='headers'
    :single-select='true'
    @input='rowClicked')
    template(v-slot:row='{item, index, selected, expanded}')
      td
        router-link(:to='`/${item.type}/${item.guid}`' target='_blank') {{item.name}}
      td {{item.type}}/{{item.gitName | truncate(40)}}
      td {{item.author.name}} ({{item.author.email}})
      td
        time-ago(:date='item.updatedAt')
      td
        v-row.buttons
          v-tooltip(bottom)
            template(v-slot:activator='{on}')
              v-btn.ma-0(v-on='on' text icon @click.stop.prevent='discard(item)')
                v-icon delete
            span Discard Changes
          v-tooltip(bottom)
            template(v-slot:activator='{on}')
              v-btn.ma-0(v-on='on' text icon :href='`/${item.type}/${item.guid}`' target='blank')
                v-icon open_in_new
            span Open In New Tab
          v-tooltip(bottom)
            template(v-slot:activator='{on}')
              v-btn.ma-0(v-on='on' text icon @click='select(item)')
                v-icon compare_arrows
            span Show Changes
    template(v-slot:item='{item}')
      v-row(no-gutters)
        v-col(cols='12').text-body-1.pa-3
          .text-subtitle-1
            router-link(:to='`/${item.type}/${item.guid}`') {{item.name}}
          v-row(no-gutters)
            v-col.text-body-2(cols='4' sm='3') Filename:
            v-col {{item.type}}/{{item.gitName | truncate(40)}}
          v-row(no-gutters)
            v-col.text-body-2(cols='4' sm='3') Author:
            v-col {{item.author.name}} ({{item.author.email}})
          v-row(no-gutters)
            v-col.text-body-2(cols='4' sm='3') Updated:
            v-col
              time-ago(:date='item.updatedAt')
          v-row(justify='end')
            v-tooltip(bottom)
              template(v-slot:activator='{on}')
                v-btn.ma-0(v-on='on' text icon @click.stop.prevent='discard(item)')
                  v-icon delete
              span Discard Changes
            v-tooltip(bottom)
              template(v-slot:activator='{on}')
                v-btn.ma-0(v-on='on' text icon :href='`/${item.type}/${item.guid}`' target='blank')
                  v-icon open_in_new
              span Open In New Tab
            v-tooltip(bottom)
              template(v-slot:activator='{on}')
                v-btn.ma-0(v-on='on' text icon @click='select(item)')
                  v-icon compare_arrows
              span Show Changes
      // </tr> (Gets put inside tr)
</template>

<script>
import {size, first} from 'lodash';
import TableList from './TableList';
import TimeAgo from './TimeAgo';

export default {
  name: 'BionicMetricsUncommittedChanges',
  components: {TimeAgo, TableList},
  props: {
    loading: {
      type: Boolean
    },
    changes: {
      required: true,
      default() {
        return [];
      }
    }
  },
  computed: {
    total() {
      if (!this.changes) return 0;
      return size(this.changes);
    }
  },
  methods: {
    select(item) {
      if (!item) return;
      this.$emit('diff', item);
    },
    discard(item) {
      this.$emit('discard', item);
    },
    rowClicked(selection) {
      this.select(first(selection));
    }
  },
  data() {
    return {
      headers: [
        // {text: '', value: 'select', sortable: false},
        {text: 'Name', value: 'name', sortable: false},
        {text: 'Filename', value: 'gitName', sortable: false},
        {text: 'Author', value: 'author', sortable: false},
        {text: 'Updated', value: 'updatedAt', sortable: false},
        {text: 'Actions', value: 'actions', sortable: false}
      ]
    };
  }
};

</script>

<style scoped>
</style>
